export const clientData = $state({
  theme: "blue",
  ShowNavPages: ["/", "/play", "/ball", "/my", "/bbs/home",'/my/activities'], //显示导航的页面
  //配置信息
  config: {},
  user: {},
  apiConfig: {},
  footerShow: true,
  toasterShow: false,
  deviceId: "H5|000",
  // 基础配置信息
  baseInfo: {},
  assets: {}, //租户相关资源
  texts: {}, //租户相关文案
  auth: null,
  testHost: "https://h5-new.9rmgd.cc",
  // my模块
  my: {},
  // 竞彩足球
  lotterFootball: {},
  // 论坛模块
  bbs: {},
  // 平台文本信息
  texts: {},
  // 首页
  home: {
    noticeDataLoaded: false,
    textDialogVisible: false,
    imgDialogVisible: false,
    redPacketDialogVisible: false,
    textDialogVisibled: false,
    imgDialogVisibled: false,
    redPacketDialogVisibled: {},
  },
  isBack: 0, // 是否返回打开 1:是 0:否

  // 红包雨是否显示
  redPacketRainVisible: false,
  // 首页弹窗是否显示
  homeDialogVisible: false,

  // 充值页面
  withdraw: {
    abpayConfig: {},
    withdrawTypes: [],
  },

  // 消息
  notice: {
    stationLetterList: [],
    announcementList: [],
  },
  flutterTheme:
    {
      blue: 1,
      gold: 3,
      orange: 2,
      purple: 4,
    }[import.meta.env.VITE_THEME] || 1,
});
